import styled from 'styled-components';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';
import { ADivider as ADividerComponent } from '../../atoms/ADivider';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacers?.spacers?.[1]};
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacers?.spacers?.[2]};
  padding-inline-end: ${spacers?.spacers?.[1]};
`;

export const ADivider = styled(ADividerComponent)`
  margin-block: ${spacers?.spacers?.[1]};
`;
